<template>
  <v-card style="height: 100%">
    <v-card-text>
      <p class="ma-0">
        <slot></slot>
      </p>
      <h3 class="headline text-xs-right">
        <pulse-loader :color="$vuetify.theme.primary" :size="'5px'" v-if="loading"></pulse-loader>
        <tween-num v-else :value="parseInt(value)" :initial="0" :formatter="numberFormat"></tween-num>
      </h3>
    </v-card-text>
  </v-card>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import TweenNum from 'vue-tween-number'
import numeral from 'numeral'
export default {
  props: ['value', 'loading'],
  data: function() {
    return {}
  },
  components: {
    TweenNum,
    PulseLoader
  },
  methods: {
    numberFormat: function(val) {
      return numeral(val).format('0,0')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/dashboard/StatCard.vue